  $(document).off('click', '.custom-btn-cart-drawer');

  $(document).on('click', '.custom-btn-cart-drawer', function(event) {
    event.preventDefault();
    const product_id = $(this).attr('data-product-id');
    const product_variant_id = $(this).attr('data-product-variant-id');
    const product_quantity = $(this).parent().parent().find('.ajaxcart__qty-num').val();

itemErrorCallback = function (XMLHttpRequest, textStatus) {
  var data = JSON.parse(XMLHttpRequest.responseText);
  console.log(data.description);

  var $customContainer = $('.cart-drawer-products-wrapper').eq(1);

  if ($customContainer.length) {
    var $addErrorMessage = $customContainer.find('.cart-drawer-item-wrapper').last();

    if ($addErrorMessage.length) {
      if (!data.message || data.status != 422) {
        $addErrorMessage.after(
          '<div class="errors qty-error">An error occurred. Please try again later</div>'
        );
      }

      if (data.message && data.status == 422) {
        $addErrorMessage.after(
          '<div class="errors qty-error">' + data.description + '</div>'
        );
      }
    } else {
      console.warn('No cart-drawer-item-wrapper found to insert error.');
    }
  } else {
    console.warn('No cart-drawer-products-wrapper found.');
  }
};


    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: {
        'id': product_variant_id,
        'form_type': 'product',
        'product-id': product_id,
        'quantity': product_quantity,
      },
      dataType: 'json',
      success: function(line_item) {
        if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
          ajaxCart.load();
        }
        else {
          Shopify.onItemAdded(line_item);
        } 
      },
      error: function(XMLHttpRequest, textStatus) {
         if ((typeof itemErrorCallback) === 'function') {
          itemErrorCallback(XMLHttpRequest, textStatus);
        }
        else {
          alert('An error occurred. Please try again later');
        } 
      }
    };
    jQuery.ajax(params);
  })
